import Footer from '@components/organisms/FooterNew'
// import Header from '@components/organisms/Header/Header'
// import DifferentPlatform from '@components/pages/advantageous/DifferentPlatform'
import Edugram500 from '@components/pages/advantageous/Edugram500'
import Explore from '@components/pages/advantageous/Explore'
import FAQSection from '@components/pages/advantageous/FAQSection'
import HeroSection from '@components/pages/advantageous/HeroSection'
import PublishCourse from '@components/pages/advantageous/PublishCourse'
import Testimonials from '@components/pages/advantageous/Testimonials'
import dynamic from 'next/dynamic'
const AuthorDetailsModal = dynamic(
  () => import('@components/pages/become-author/AuthorDetailsModal'),
  { ssr: false }
)
import Header from '@components/pages/home/LandingPage/Sections/Header'
import EdugramPricing from '@components/pages/pricing/EdugramPricing'
import { useAuth } from '@contexts/Auth'
import styled from '@emotion/styled'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import withLenis from '@components/HOCs/LenisWrapper'

type Props = {}

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
        'authentication',
        'footer',
        'courses',
        'signUp',
        'home',
        'wishlist',
        'cartModal',
        'wishlistDropdown',
        'errors',
        'advantageous',
        'homeLanding/header',
        'landingPage',
      ])),
    },
  }
}

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const ChildWrapper = styled.div`
  @media screen and (max-width: 1525px) {
    padding: 0px 0.8rem;
  }
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const PricingPageRoot = ({}: Props) => {
  const { t } = useTranslation('advantageous')
  const [showBecomeAuthorModal, setShowBecomeAuthorModal] = useState(false)
  const { user, isAuthenticated, setShowAuthModal } = useAuth()
  const freshLoggedIn = useRef(false)
  const router = useRouter()

  useEffect(() => {
    if (user && !user?.isAuthor && freshLoggedIn.current) {
      setShowBecomeAuthorModal(true)
    }

    return () => {
      freshLoggedIn.current = false
    }
  }, [user])

  const handleBecomeCreator = () => {
    if (!isAuthenticated) {
      setShowAuthModal(true)
      freshLoggedIn.current = true
      return
    }
    if (user?.isAuthor) router.push('/author')
    else setShowBecomeAuthorModal(true)
  }

  return (
    <>
      <Head>
        <title>{t('pricing.pageTitle')}</title>
      </Head>
      <MainWrapper>
        <ChildWrapper>
          <Header handleBecomeCreator={handleBecomeCreator} />
        </ChildWrapper>
        <BodyWrapper>
          <HeroSection
            title={t('pricing.heroTitle')}
            description={t('pricing.heroDescription')}
            handleBecomeCreator={handleBecomeCreator}
          />
          {/* <DifferentPlatform /> */}
          <EdugramPricing />
          <Edugram500 removeButton={true} />
          <PublishCourse handleBecomeCreator={handleBecomeCreator} />
          <Testimonials />
          <FAQSection />
          <Explore />
        </BodyWrapper>
        <ChildWrapper>
          <Footer />
        </ChildWrapper>
        {showBecomeAuthorModal && (
          <AuthorDetailsModal
            isOpen={showBecomeAuthorModal}
            onClose={(ask?: boolean) => {
              if (ask) {
                if (confirm('Are you sure you want to close?')) {
                  setShowBecomeAuthorModal((prev) => !prev)
                }
              } else {
                setShowBecomeAuthorModal((prev) => !prev)
              }
            }}
          />
        )}
      </MainWrapper>
    </>
  )
}

export default withLenis(PricingPageRoot)
